/**
 * Ícones de linha 24×24, no mesmo traço do app (strokeWidth 1.8, sem
 * preenchimento). Os três primeiros são portados de
 * card-game-app/src/components/CardTile.tsx (espada / raio / escudo), para que
 * o site use a mesma linguagem visual do jogo em vez de emojis.
 *
 * Todos usam `currentColor`, então quem chama define a cor pelo CSS.
 */
import type { CardType } from '../types/catalog';

const BASE = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.8,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
} as const;

/** Espada / raio / escudo, conforme o tipo da carta. */
export function CardTypeIcon({
  type,
  size = 34,
}: {
  type: CardType;
  size?: number;
}): React.JSX.Element {
  return (
    <svg {...BASE} width={size} height={size} role="presentation" aria-hidden>
      {type === 'unit' && (
        <>
          <path d="M12 2 V14" />
          <path d="M8.5 14 H15.5" />
          <path d="M12 14 V19" />
        </>
      )}
      {type === 'spell' && <path d="M13 2 L6 13 L11 13 L9 22 L18 9 L12 9 Z" />}
      {type === 'trap' && (
        <>
          <path d="M12 3 L19 6 V11 C19 16 12 21 12 21 C12 21 5 16 5 11 V6 Z" />
          <path d="M12 9 V14 M9.5 11.5 H14.5" />
        </>
      )}
    </svg>
  );
}

/** Mapa dobrado — usado nos territórios. */
export function MapIcon({ size = 34 }: { size?: number }): React.JSX.Element {
  return (
    <svg {...BASE} width={size} height={size} role="presentation" aria-hidden>
      <path d="M9 4 L3 6.5 V20 L9 17.5 L15 20 L21 17.5 V4 L15 6.5 Z" />
      <path d="M9 4 V17.5" />
      <path d="M15 6.5 V20" />
    </svg>
  );
}

/** Livro aberto — usado nas regras. */
export function BookIcon({ size = 34 }: { size?: number }): React.JSX.Element {
  return (
    <svg {...BASE} width={size} height={size} role="presentation" aria-hidden>
      <path d="M12 6.5 C10 4.5 6.5 4.2 3.5 4.8 V18.4 C6.5 17.8 10 18.1 12 20" />
      <path d="M12 6.5 C14 4.5 17.5 4.2 20.5 4.8 V18.4 C17.5 17.8 14 18.1 12 20" />
      <path d="M12 6.5 V20" />
    </svg>
  );
}

/** Duas cartas sobrepostas — usado no catálogo de cartas. */
export function DeckIcon({ size = 34 }: { size?: number }): React.JSX.Element {
  return (
    <svg {...BASE} width={size} height={size} role="presentation" aria-hidden>
      <rect x="8.5" y="3.5" width="12" height="15" rx="2" />
      <path d="M15.5 20.5 H5.5 A2 2 0 0 1 3.5 18.5 V7.5" />
    </svg>
  );
}
